<script>
  import formasPagamento from '~modulos/solicitacao-faturamento/formas-pagamento';
  import radio from '~componentes/Radio.vue';
  import unidadeServico from '~modulos/unidade/servico';
  import codItemServicoServico from '~modulos/cod-item-servico/servico';
  import DadosBancarios from './FormDadosBancarios.vue';

  export default {
    components: { radio, DadosBancarios },
    props: {
      solicitacao: {
        type: Object,
        required: true
      },
      edicao: {
        type: Boolean,
        required: false,
        default: false,
      },
      dadosBancarios: {
        type: Array,
        required: true,
      },
    },
    data() {
      return {
        formasPagamento: formasPagamento,
        unidades: [],
        departamentos: [],
        codItemServico: [],
      }
    },
    computed: {
      complementoContador() {
        let quantidadeCaracteres = this.solicitacao.complemento ?
          this.solicitacao.complemento.length : 0;

        return 500 - quantidadeCaracteres;
      }
    },
    methods: {
      validar(valido) {
        if (!valido) throw new Error("validacao com erro");
        
        return this.$validator.validateAll();
      },
      limparDadosBancarios() {
        if (this.solicitacao.formaPagamento == '0') {
          this.solicitacao.banco = '';
          this.solicitacao.agencia = '';
          this.solicitacao.contaCorrente = '';
          this.solicitacao.tipoConta = '';
        }
      },
      listaUnidades() {
        return unidadeServico
          .lista()
          .then(unidades => {
            this.unidades = unidades;
          });
      },
      listaDepartamentos(idUnidade) {
        this.departamentos = [];

        if (this.solicitacao.idUnidade === '') {
          return;
        }

        return unidadeServico
          .departamentos(this.solicitacao.idUnidade)
          .then(departamentos => {
            this.departamentos = departamentos;
          });
      },
      listaCodItemServico() {
        return codItemServicoServico
          .lista()
          .then(codItemServico => {
            this.codItemServico = codItemServico;
          });
      },
      calcularDataPagamento() {
        switch (this.solicitacao.tipoPagamento) {
          case 0:
          case 2:
            this.solicitacao.dataPagamento = moment().add(7, 'days').format('DD/MM/YYYY');
            break;
          case 1:
            this.solicitacao.dataPagamento = moment().add(30, 'days').format('DD/MM/YYYY');
            break;
        }
      }
    },
    mounted() {
      this.listaUnidades();
      this.listaCodItemServico();
      this.calcularDataPagamento();
    },
    watch: {
      'solicitacao.formaPagamento': 'limparDadosBancarios'
    }
  }
</script>

<template>
  <div>

    <div class="row">
      <div class="col-lg-6">
        <div class="form-group required">
          <label class="control-label" for="forma-pagamento">Forma de pagamento</label>

          <select
            class="form-control"
            id="forma-pagamento"
            v-model="solicitacao.tipoPagamento"
            @change="calcularDataPagamento">
            <option :value="formaPagamento.id" v-for="formaPagamento in formasPagamento">{{ formaPagamento.nome }}</option>
          </select>
        </div>
      </div>

      <div class="col-lg-6">
        <div class="form-group required">
          <label class="control-label">Data de vencimento</label>

          <input
            class="form-control"
            type="text"
            v-model="solicitacao.dataPagamento"
            disabled>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-lg-6">
        <div class="form-group required" :class="{'has-error': errors.has('unidade')}">
          <label class="control-label" for="unidade">Unidade</label>

          <select
            id="unidade"
            class="form-control"
            v-model="solicitacao.idUnidade"
            data-vv-name="unidade"
            data-vv-as="unidade"
            v-validate="'required'"
            @change="listaDepartamentos">
            <option value="">Selecione...</option>
            <option :value="unidade.idUnidade" v-for="unidade in unidades">{{ unidade.nomeUnidade }}</option>
          </select>

          <p class="text-danger" v-show="errors.has('unidade')">{{ errors.first('unidade') }}</p>
        </div>
      </div>

      <div class="col-lg-6">
        <div class="form-group required" :class="{'has-error': errors.has('departamento')}">
          <label class="control-label" for="departamento">Departamento</label>

          <select
            id="departamento"
            class="form-control"
            v-model="solicitacao.idDepartamento"
            data-vv-name="departamento"
            data-vv-as="departamento"
            v-validate="'required'">
            <option value="">{{ solicitacao.idUnidade === '' ? 'Selecione a unidade...' : 'Selecione...' }}</option>
            <option :value="departamento.idDepartamento" v-for="departamento in departamentos">{{ departamento.nomeDepartamento }}</option>
          </select>

          <p class="text-danger" v-show="errors.has('departamento')">{{ errors.first('departamento') }}</p>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-lg-12">
        <div class="form-group">
          <radio
              v-model="solicitacao.formaPagamento"
              selected-value="0"
              type="success"
              :inline="true"
              class="no-margin-bottom no-margin-top margin-right-10">
            Boleto bancário
          </radio>
          
          <radio
              v-model="solicitacao.formaPagamento"
              selected-value="1"
              type="success"
              :inline="true"
              class="no-margin-bottom no-margin-top">
            Depósito em conta
          </radio>
        </div>
      </div>
    </div>
    
    <dados-bancarios 
        :solicitacao="solicitacao" 
        :dados-bancarios="dadosBancarios"
        v-show="solicitacao.formaPagamento == 1">
    </dados-bancarios>
    
    <div class="row">
      <div class="col-lg-12">
        <div class="form-group required" :class="{'has-error': errors.has('observacao')}">
          <label class="control-label" for="observacao">Enviar email para</label>

          <input
            type="text"
            class="form-control"
            id="observacao"
            maxlength="300"
            v-model="solicitacao.observacao"
            data-vv-name="observacao"
            data-vv-as="enviar email para"
            v-validate="'required'">

          <p class="text-danger" v-show="errors.has('observacao')">{{ errors.first('observacao') }}</p>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-lg-12">
        <div class="form-group required" :class="{'has-error': errors.has('idCodItemServico')}">
          <label class="control-label" for="codigo-servico">Código do serviço</label>

          <select
            id="codigo-servico"
            class="form-control"
            v-model="solicitacao.idCodItemServico"
            data-vv-name="idCodItemServico"
            data-vv-as="código do serviço"
            v-validate="'required'">
            <option value="">Selecione...</option>
            <option :value="c.idCodItemServico" v-for="c in codItemServico">{{ c.descricao }}</option>
          </select>

          <p class="text-danger" v-show="errors.has('idCodItemServico')">{{ errors.first('idCodItemServico') }}</p>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-lg-12">
        <div class="form-group required" :class="{'has-error': errors.has('complemento')}">
          <label class="control-label" for="complemento">Observação (cotação, condições de pagamento e pedido de compra) ({{ complementoContador }})</label>

          <textarea
            id="complemento"
            class="form-control"
            v-model="solicitacao.complemento"
            data-vv-name="complemento"
            data-vv-as="observação"
            v-validate="'required'"
            maxlength="500">
          </textarea>

          <p class="text-danger" v-show="errors.has('complemento')">{{ errors.first('complemento') }}</p>
        </div>
      </div>
    </div>

  </div>
</template>



// WEBPACK FOOTER //
// FrontEnd/modulos/solicitacao-faturamento-multiservicos/componentes/compartilhado/FormDadosFatura.vue